import { useServices } from '../../../services/useServices';
import { usePipelineQuery } from './usePipelineQuery';

export const useBookstatDataFlow = () => {
  const { pipelines } = useServices();

  return usePipelineQuery(
    ['pipelines', 'data-flow'],
    () => pipelines.getDataFlow()
  );
};
